import { replace } from 'connected-react-router';

import apiSubmitQuiz from '../../utils/quiz/quizApi';
import { trackContent } from '../../utils/facebookPixel';

import {
    ACTION_COMPLETED_LOCAL_REP,
    SHOW_NEXT_ACTION_ANIMATION,
    IS_NEXT_ACTION_TRANSITION,
    onFinishMultiAction
} from '../Widget/actions';

export const QUIZ_ANSWER_SUBMITTING = 'QUIZ_ANSWER_SUBMITTING';
export const QUIZ_SUCCESS = 'QUIZ_SUCCESS';
export const QUIZ_INITIATED = 'QUIZ_INITIATED';
export const SET_SUCCESS_INFO = 'SET_SUCCESS_INFO';

export const onAnswerClick = (
    apiRequestData,
    answerId,
    answerText,
    actionIdentifier,
    actionCompletedTime,
    isMultiActionsCard,
    answers,
    feedbackText,
    showEmailInterstitial,
    onShowEmailInterstitial,
    widgetId,
    questionText,
    skipEndCard,
    actionInitiated
) => dispatch => {
    if (!actionInitiated) {
        dispatch({
            type: QUIZ_INITIATED,
            payload: actionIdentifier
        });
    }
    if (showEmailInterstitial) {
        setTimeout(function() {
            onShowEmailInterstitial();
        }, 600);
    }

    dispatch({
        type: QUIZ_ANSWER_SUBMITTING,
        payload: true
    });

    var answerButton = document.querySelectorAll(
        "[data-answer='" + answerText.replace("'", "\\'") + "']"
    )[0];
    answerButton.classList.add('selected');
    answerButton.disabled = true;

    var dataAnswerVisible = document.querySelectorAll('[data-answer]');
    for (var i = 0; i < dataAnswerVisible.length; i++) {
        if (dataAnswerVisible[i].dataset.answer !== answerText) {
            dataAnswerVisible[i].disabled = true;
        }
    }

    trackContent('quiz', widgetId, actionIdentifier, questionText, answerId, answerText);

    apiSubmitQuiz(apiRequestData, answerId, answerText, actionCompletedTime).then(
        data => {
            var arr = [];
            setTimeout(() => {
                var dataAnswer = document.querySelectorAll('[data-visibility]');
                var dataAnswerBar = document.querySelectorAll('[data-bar]');
                var dataAnswerText = document.querySelectorAll('[data-text]');
                for (var i = 0; i < dataAnswer.length; i++) {
                    arr.push(dataAnswer[i].dataset.height);
                }
                var highest = Math.max.apply(0, arr);
                var defConst = isMultiActionsCard ? 95 : 100;
                var defBotConst = isMultiActionsCard ? 12 : 5;

                for (i = 0; i < dataAnswer.length; i++) {
                    dataAnswer[i].dataset.visibility = 'true';
                    var total =
                        (parseInt(dataAnswer[i].dataset.height, 10) * defConst) / highest;
                    dataAnswerBar[i].style.height = total + 'px';
                    dataAnswerText[i].style.bottom = total + defBotConst + 'px';
                }
            }, 600);

            dispatch({
                type: QUIZ_SUCCESS,
                payload: { ...data, answerId, actionIdentifier, answers, feedbackText }
            });

            dispatch({
                type: SET_SUCCESS_INFO,
                payload: {
                    feedbackText
                }
            });

            if (!skipEndCard) {
                dispatch({
                    type: IS_NEXT_ACTION_TRANSITION,
                    payload: true
                });

                dispatch({
                    type: SHOW_NEXT_ACTION_ANIMATION
                });
            }

            dispatch({
                type: ACTION_COMPLETED_LOCAL_REP
            });

            if (!showEmailInterstitial) {
                if (isMultiActionsCard) {
                    onFinishMultiAction(actionIdentifier)(dispatch);
                } else if (!skipEndCard) {
                    dispatch(replace('/quiz/success'));
                }
            }

            dispatch({
                type: QUIZ_ANSWER_SUBMITTING,
                payload: false
            });
        }
    );

    return true;
};
